module.exports = __webpack_public_path__ + "static/media/IMG_3670.5c1a1cce.jpg";